var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 23 16",
    width: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.4043 15.3633c2.6719 0 4.7778-1.9668 4.7778-4.4068 0-1.84615-1.0669-3.46041-2.7925-4.18404.0186-3.93359-2.811-6.77246-6.4292-6.77246-2.3657 0-4.0727 1.25244-5.1396 2.80176-2.18945-.62158-4.53662 1.02978-4.59228 3.49756-1.99463.3247-3.22852 2.10595-3.22852 4.26758 0 2.6069 2.28223 4.7964 5.30664 4.7964zm-6.9395-3.4976c-.2968 0-.53804-.1206-.7607-.3989l-1.95752-2.46778c-.13916-.17627-.21338-.36181-.21338-.54736 0-.42676.33399-.74219.73291-.74219.26905 0 .4917.12061.65869.35254l1.5029 1.94829 2.9781-4.96342c.1484-.25977.3896-.40821.6494-.40821.4267 0 .7607.29688.7607.6958 0 .2041-.1113.40821-.1948.55664l-3.4419 5.55709c-.167.2784-.4175.4175-.7144.4175z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.3665cda9.svg";
export { ForwardRef as ReactComponent };